import { render, staticRenderFns } from "./ORegisterPassEditComp.vue?vue&type=template&id=e71d2cda&scoped=true&"
import script from "./ORegisterPassEditComp.vue?vue&type=script&lang=ts&"
export * from "./ORegisterPassEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./ORegisterPassEditComp.vue?vue&type=style&index=0&id=e71d2cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71d2cda",
  null
  
)

export default component.exports